import type { MRT_ColumnDef } from "mantine-react-table-open";
import type {
  EnergyRevenuesListItem,
  GetEnergyRevenuesTableColumnParams
} from "../../../RevenueMonitoring.types";
import { getDirektvermarktungFeeColumn } from "../columns/getDirektvermarktungFeeColumn";
import { getDirektvermarktungNetRevenueColumn } from "../columns/getDirektvermarktungNetRevenueColumn";
import { getDirektvermarktungVolumeColumn } from "../columns/getDirektvermarktungVolumeColumn";
import { getNetRevenueMinusFeeColumn } from "../columns/getNetRevenueMinusFeeColumn";

export function getDirectMarketingColumnGroup({
  companyId,
  dataVerificationColumns,
  dataVerificationItems,
  columnVisibility
}: GetEnergyRevenuesTableColumnParams): MRT_ColumnDef<EnergyRevenuesListItem> {
  return {
    id: "direct_marketing",
    header:
      "Vermarktungserlös tatsächliche Einspeisung (Abrechnung Vermarkter)",
    mantineTableHeadCellProps: {
      className: "column-group-header-border-left"
    },
    columns: [
      getDirektvermarktungVolumeColumn({
        companyId,
        dataVerificationColumns,
        dataVerificationItems,
        columnVisibility
      }),
      getDirektvermarktungNetRevenueColumn({
        companyId,
        dataVerificationColumns,
        dataVerificationItems,
        columnVisibility
      }),
      getDirektvermarktungFeeColumn({
        companyId,
        dataVerificationColumns,
        dataVerificationItems,
        columnVisibility
      }),
      getNetRevenueMinusFeeColumn({
        companyId,
        dataVerificationColumns,
        dataVerificationItems,
        columnVisibility
      })
    ]
  };
}
